import React from "react";
import { createRoot } from "react-dom/client"; // Përdorimi i "createRoot" nga "react-dom/client"
import App from "./App";
import { FiscalYearProvider } from "./FiscalYear/FiscalYearContext";
import { VatDeclarantProvider } from "./GetData/Context/CompanyDataContext";
import reportWebVitals from "./reportWebVitals";
import { LicenseProvider } from "./GetData/Context/LicenseContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// import './index.css';
// const root = createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
const root = createRoot(document.getElementById("root"));
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <FiscalYearProvider>
        {" "}
        {/* Mbështjell aplikacionin me FiscalYearProvider */}
        <VatDeclarantProvider>
          <LicenseProvider>
            <App />
          </LicenseProvider>
        </VatDeclarantProvider>
      </FiscalYearProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);

// if ("serviceWorker" in navigator) {
//   window.addEventListener("load", () => {
//     navigator.serviceWorker
//       .register("/service-worker.js")
//       .then((registration) => {
//         console.log("Service Worker registered with scope:", registration.scope);
//       })
//       .catch((error) => {
//         console.error("Service Worker registration failed:", error);
//       });
//   });
// }
function checkForNewVersion() {
  fetch("/version.json")
    .then((res) => res.json())
    .then((data) => {
      const currentVersion = localStorage.getItem("appVersion");
      if (currentVersion && currentVersion !== data.version) {
        alert(
          "Një version i ri është i disponueshëm! Kliko OK për të rifreskuar.",
        );
        localStorage.setItem("appVersion", data.version);
        window.location.reload();
      } else {
        localStorage.setItem("appVersion", data.version);
      }
    })
    .catch((error) =>
      console.error("Gabim gjatë kontrollit të versionit:", error),
    );
}

// Kontrollo versionin çdo 30 sekonda
setInterval(checkForNewVersion, 30000);

reportWebVitals();

// import React from "react";
// import ReactDOM from "react-dom";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";

// ReactDOM.render(
//   <React.StrictMode>
//     <App/>
//   </React.StrictMode>,
//   document.getElementById("root")
// );

// reportWebVitals();
